var map = {
	"./ability.png": 773,
	"./account2x.png": 6567,
	"./account3x.png": 6568,
	"./accounts.png": 518,
	"./albarakaApi.png": 774,
	"./albaraka_api.png": 6569,
	"./albaraka_api2.png": 6570,
	"./albaraka_api_v1.png": 6571,
	"./albaraka_api_white.png": 775,
	"./albaraka_logo.png": 776,
	"./albaraka_logo2.png": 6572,
	"./albarakagaraj_logo.png": 777,
	"./albarakagaraj_logo2.png": 6573,
	"./alneo_logo.png": 6574,
	"./alneo_logo2.png": 6575,
	"./analytics.png": 526,
	"./api_footer.png": 6576,
	"./app_icon.png": 530,
	"./atg.png": 778,
	"./baas_onboarding.png": 6577,
	"./become.png": 779,
	"./business.png": 780,
	"./cancels.png": 527,
	"./community.png": 781,
	"./createApi.png": 6578,
	"./createApps.png": 6579,
	"./createApps2.png": 6580,
	"./createApps3.png": 6581,
	"./creditcard.png": 529,
	"./debitCard.png": 6582,
	"./developApi.png": 782,
	"./developApp.png": 6583,
	"./developers.png": 783,
	"./digitalLoan.png": 6584,
	"./discover.png": 6585,
	"./discoverAnimation.png": 6586,
	"./discoverAnimationText.png": 6587,
	"./documentation.png": 784,
	"./facebook.png": 6588,
	"./facebook@2x.png": 6589,
	"./fail.png": 785,
	"./gettingstart.png": 6590,
	"./goLive.png": 6591,
	"./goLiveApi.png": 6592,
	"./homepage.1.png": 6593,
	"./homepage.png": 6594,
	"./homepage2.png": 6595,
	"./how-it-works-2.png": 769,
	"./how-it-works.png": 6596,
	"./how-it-works@2x.png": 768,
	"./informationservices.png": 520,
	"./innovators.png": 786,
	"./insha_logo.png": 6597,
	"./insha_logo2.png": 6598,
	"./instant.png": 787,
	"./investmentproducts.png": 521,
	"./join.png": 788,
	"./leststart.png": 6599,
	"./letsbuild.png": 789,
	"./loansfinancing.png": 522,
	"./mailOrder.png": 6600,
	"./medium.png": 790,
	"./mediumBlack.png": 791,
	"./moneytransfers.png": 523,
	"./moneytransfersinsha.png": 524,
	"./partnership.png": 792,
	"./payments.png": 519,
	"./pinterest.png": 6601,
	"./pinterest@2x.png": 6602,
	"./postman1.png": 696,
	"./postman2.png": 697,
	"./prime.png": 793,
	"./qr.png": 6603,
	"./register.png": 6604,
	"./register2.png": 6605,
	"./register3.png": 6606,
	"./registerAnimation.png": 6607,
	"./scrollButton.png": 794,
	"./simple.png": 795,
	"./slack.png": 796,
	"./slackBlack.png": 797,
	"./success.png": 342,
	"./success_old.png": 6608,
	"./support.png": 798,
	"./takbis.png": 528,
	"./twitter.png": 6609,
	"./twitter@2x.png": 6610,
	"./user.png": 799,
	"./virtualpos.png": 525,
	"./weare.png": 6611,
	"./webhooks.png": 6612,
	"./whyYouShould.png": 6613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 772;